// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CodeRouteImport } from './routes/$code'
import { Route as AppRouteImport } from './routes/app'
import { Route as BoostRouteImport } from './routes/boost'
import { Route as CategoriesRouteImport } from './routes/categories'
import { Route as CookieRouteImport } from './routes/cookie'
import { Route as EarnRouteImport } from './routes/earn'
import { Route as FundRouteImport } from './routes/fund'
import { Route as GetHotRouteImport } from './routes/get-hot'
import { Route as HowItWorksRouteImport } from './routes/how-it-works'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MarketplaceRouteImport } from './routes/marketplace'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PromoteRouteImport } from './routes/promote'
import { Route as ReferralsRouteImport } from './routes/referrals'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as WithdrawalRouteImport } from './routes/withdrawal'
import { Route as AppIndexRouteImport } from './routes/app.index'
import { Route as AppBillingRouteImport } from './routes/app.billing'
import { Route as AppCollabsRouteImport } from './routes/app.collabs'
import { Route as AppMessagesRouteImport } from './routes/app.messages'
import { Route as AppNotificationsRouteImport } from './routes/app.notifications'
import { Route as AppOrdersRouteImport } from './routes/app.orders'
import { Route as AppProRouteImport } from './routes/app.pro'
import { Route as AppProfileRouteImport } from './routes/app.profile'
import { Route as AppReferralsRouteImport } from './routes/app.referrals'
import { Route as AppTransactionsRouteImport } from './routes/app.transactions'
import { Route as AppWalletsRouteImport } from './routes/app.wallets'
import { Route as CSlugRouteImport } from './routes/c.$slug'
import { Route as HistoryIndexRouteImport } from './routes/history.index'
import { Route as HotIndexRouteImport } from './routes/hot.index'
import { Route as HotTopicRouteImport } from './routes/hot.$topic'
import { Route as MarketplaceIndexRouteImport } from './routes/marketplace.index'
import { Route as MarketplaceCategoriesRouteImport } from './routes/marketplace.categories'
import { Route as MarketplaceExploreRouteImport } from './routes/marketplace.explore'
import { Route as MarketplaceFavoritesRouteImport } from './routes/marketplace.favorites'
import { Route as MarketplaceHotRouteImport } from './routes/marketplace.hot'
import { Route as MarketplaceOffersRouteImport } from './routes/marketplace.offers'
import { Route as MarketplaceOrdersRouteImport } from './routes/marketplace.orders'
import { Route as MarketplaceRequestsRouteImport } from './routes/marketplace.requests'
import { Route as MarketplaceSellRouteImport } from './routes/marketplace.sell'
import { Route as PSlugRouteImport } from './routes/p.$slug'
import { Route as ProSlugRouteImport } from './routes/pro.$slug'
import { Route as UHandleRouteImport } from './routes/u.$handle'
import { Route as UserSlugRouteImport } from './routes/user.$slug'
import { Route as AppInvoicesIndexRouteImport } from './routes/app.invoices.index'
import { Route as AppInvoicesIdRouteImport } from './routes/app.invoices.$id'
import { Route as AppListingsIdRouteImport } from './routes/app.listings.$id'
import { Route as CompareHotIndexRouteImport } from './routes/compare.hot.index'
import { Route as CompareHotCompetitorRouteImport } from './routes/compare.hot.$competitor'
import { Route as CompareHotOutbidRouteImport } from './routes/compare.hot.outbid'
import { Route as CompareMarketplaceIndexRouteImport } from './routes/compare.marketplace.index'
import { Route as CompareMarketplaceCompetitorRouteImport } from './routes/compare.marketplace.$competitor'
import { Route as HistoryYearIndexRouteImport } from './routes/history.$year.index'
import { Route as MarketplaceUsernameServiceSlugRouteImport } from './routes/marketplace.$username.$serviceSlug'
import { Route as MarketplaceCategorySlugRouteImport } from './routes/marketplace.category.$slug'
import { Route as MarketplaceGuidesIndexRouteImport } from './routes/marketplace.guides.index'
import { Route as MarketplaceGuidesSlugRouteImport } from './routes/marketplace.guides.$slug'
import { Route as MarketplaceOrderOrderIdRouteImport } from './routes/marketplace.order.$orderId'
import { Route as MarketplaceRequestRequestIdRouteImport } from './routes/marketplace.request.$requestId'
import { Route as MarketplaceServicesNewRouteImport } from './routes/marketplace.services.new'
import { Route as NcLiveAdmRouteImport } from './routes/nc.live.adm'
import { Route as HistoryYearMonthIndexRouteImport } from './routes/history.$year.$month.index'
import { Route as HistoryYearMonthBoardRouteImport } from './routes/history.$year.$month.$board'
import { Route as MarketplaceServicesServiceIdEditRouteImport } from './routes/marketplace.services.$serviceId.edit'
import { Route as NcLiveAdmIndexRouteImport } from './routes/nc.live.adm.index'
import { Route as NcLiveAdmAccessRouteImport } from './routes/nc.live.adm.access'
import { Route as NcLiveAdmAnalyticsRouteImport } from './routes/nc.live.adm.analytics'
import { Route as NcLiveAdmBoardsRouteImport } from './routes/nc.live.adm.boards'
import { Route as NcLiveAdmCouponsRouteImport } from './routes/nc.live.adm.coupons'
import { Route as NcLiveAdmFinanceRouteImport } from './routes/nc.live.adm.finance'
import { Route as NcLiveAdmHealthRouteImport } from './routes/nc.live.adm.health'
import { Route as NcLiveAdmHistoryRouteImport } from './routes/nc.live.adm.history'
import { Route as NcLiveAdmLedgerRouteImport } from './routes/nc.live.adm.ledger'
import { Route as NcLiveAdmListingsRouteImport } from './routes/nc.live.adm.listings'
import { Route as NcLiveAdmLogsRouteImport } from './routes/nc.live.adm.logs'
import { Route as NcLiveAdmMarketplaceRouteImport } from './routes/nc.live.adm.marketplace'
import { Route as NcLiveAdmMpRouteImport } from './routes/nc.live.adm.mp'
import { Route as NcLiveAdmNotificationsRouteImport } from './routes/nc.live.adm.notifications'
import { Route as NcLiveAdmPaymentsRouteImport } from './routes/nc.live.adm.payments'
import { Route as NcLiveAdmSegmentsRouteImport } from './routes/nc.live.adm.segments'
import { Route as NcLiveAdmServicesRouteImport } from './routes/nc.live.adm.services'
import { Route as NcLiveAdmSettingsRouteImport } from './routes/nc.live.adm.settings'
import { Route as NcLiveAdmSupportRouteImport } from './routes/nc.live.adm.support'
import { Route as NcLiveAdmUsersRouteImport } from './routes/nc.live.adm.users'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const CodeRoute = CodeRouteImport.update({
            id: '/$code',path: '/$code',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => rootRouteImport
          })
const BoostRoute = BoostRouteImport.update({
            id: '/boost',path: '/boost',getParentRoute: () => rootRouteImport
          })
const CategoriesRoute = CategoriesRouteImport.update({
            id: '/categories',path: '/categories',getParentRoute: () => rootRouteImport
          })
const CookieRoute = CookieRouteImport.update({
            id: '/cookie',path: '/cookie',getParentRoute: () => rootRouteImport
          })
const EarnRoute = EarnRouteImport.update({
            id: '/earn',path: '/earn',getParentRoute: () => rootRouteImport
          })
const FundRoute = FundRouteImport.update({
            id: '/fund',path: '/fund',getParentRoute: () => rootRouteImport
          })
const GetHotRoute = GetHotRouteImport.update({
            id: '/get-hot',path: '/get-hot',getParentRoute: () => rootRouteImport
          })
const HowItWorksRoute = HowItWorksRouteImport.update({
            id: '/how-it-works',path: '/how-it-works',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const MarketplaceRoute = MarketplaceRouteImport.update({
            id: '/marketplace',path: '/marketplace',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PromoteRoute = PromoteRouteImport.update({
            id: '/promote',path: '/promote',getParentRoute: () => rootRouteImport
          })
const ReferralsRoute = ReferralsRouteImport.update({
            id: '/referrals',path: '/referrals',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const WithdrawalRoute = WithdrawalRouteImport.update({
            id: '/withdrawal',path: '/withdrawal',getParentRoute: () => rootRouteImport
          })
const AppIndexRoute = AppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRoute
          })
const AppBillingRoute = AppBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => AppRoute
          })
const AppCollabsRoute = AppCollabsRouteImport.update({
            id: '/collabs',path: '/collabs',getParentRoute: () => AppRoute
          })
const AppMessagesRoute = AppMessagesRouteImport.update({
            id: '/messages',path: '/messages',getParentRoute: () => AppRoute
          })
const AppNotificationsRoute = AppNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => AppRoute
          })
const AppOrdersRoute = AppOrdersRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => AppRoute
          })
const AppProRoute = AppProRouteImport.update({
            id: '/pro',path: '/pro',getParentRoute: () => AppRoute
          })
const AppProfileRoute = AppProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AppRoute
          })
const AppReferralsRoute = AppReferralsRouteImport.update({
            id: '/referrals',path: '/referrals',getParentRoute: () => AppRoute
          })
const AppTransactionsRoute = AppTransactionsRouteImport.update({
            id: '/transactions',path: '/transactions',getParentRoute: () => AppRoute
          })
const AppWalletsRoute = AppWalletsRouteImport.update({
            id: '/wallets',path: '/wallets',getParentRoute: () => AppRoute
          })
const CSlugRoute = CSlugRouteImport.update({
            id: '/c/$slug',path: '/c/$slug',getParentRoute: () => rootRouteImport
          })
const HistoryIndexRoute = HistoryIndexRouteImport.update({
            id: '/history/',path: '/history/',getParentRoute: () => rootRouteImport
          })
const HotIndexRoute = HotIndexRouteImport.update({
            id: '/hot/',path: '/hot/',getParentRoute: () => rootRouteImport
          })
const HotTopicRoute = HotTopicRouteImport.update({
            id: '/hot/$topic',path: '/hot/$topic',getParentRoute: () => rootRouteImport
          })
const MarketplaceIndexRoute = MarketplaceIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MarketplaceRoute
          })
const MarketplaceCategoriesRoute = MarketplaceCategoriesRouteImport.update({
            id: '/categories',path: '/categories',getParentRoute: () => MarketplaceRoute
          })
const MarketplaceExploreRoute = MarketplaceExploreRouteImport.update({
            id: '/explore',path: '/explore',getParentRoute: () => MarketplaceRoute
          })
const MarketplaceFavoritesRoute = MarketplaceFavoritesRouteImport.update({
            id: '/favorites',path: '/favorites',getParentRoute: () => MarketplaceRoute
          })
const MarketplaceHotRoute = MarketplaceHotRouteImport.update({
            id: '/hot',path: '/hot',getParentRoute: () => MarketplaceRoute
          })
const MarketplaceOffersRoute = MarketplaceOffersRouteImport.update({
            id: '/offers',path: '/offers',getParentRoute: () => MarketplaceRoute
          })
const MarketplaceOrdersRoute = MarketplaceOrdersRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => MarketplaceRoute
          })
const MarketplaceRequestsRoute = MarketplaceRequestsRouteImport.update({
            id: '/requests',path: '/requests',getParentRoute: () => MarketplaceRoute
          })
const MarketplaceSellRoute = MarketplaceSellRouteImport.update({
            id: '/sell',path: '/sell',getParentRoute: () => MarketplaceRoute
          })
const PSlugRoute = PSlugRouteImport.update({
            id: '/p/$slug',path: '/p/$slug',getParentRoute: () => rootRouteImport
          })
const ProSlugRoute = ProSlugRouteImport.update({
            id: '/pro/$slug',path: '/pro/$slug',getParentRoute: () => rootRouteImport
          })
const UHandleRoute = UHandleRouteImport.update({
            id: '/u/$handle',path: '/u/$handle',getParentRoute: () => rootRouteImport
          })
const UserSlugRoute = UserSlugRouteImport.update({
            id: '/user/$slug',path: '/user/$slug',getParentRoute: () => rootRouteImport
          })
const AppInvoicesIndexRoute = AppInvoicesIndexRouteImport.update({
            id: '/invoices/',path: '/invoices/',getParentRoute: () => AppRoute
          })
const AppInvoicesIdRoute = AppInvoicesIdRouteImport.update({
            id: '/invoices/$id',path: '/invoices/$id',getParentRoute: () => AppRoute
          })
const AppListingsIdRoute = AppListingsIdRouteImport.update({
            id: '/listings/$id',path: '/listings/$id',getParentRoute: () => AppRoute
          })
const CompareHotIndexRoute = CompareHotIndexRouteImport.update({
            id: '/compare/hot/',path: '/compare/hot/',getParentRoute: () => rootRouteImport
          })
const CompareHotCompetitorRoute = CompareHotCompetitorRouteImport.update({
            id: '/compare/hot/$competitor',path: '/compare/hot/$competitor',getParentRoute: () => rootRouteImport
          })
const CompareHotOutbidRoute = CompareHotOutbidRouteImport.update({
            id: '/compare/hot/outbid',path: '/compare/hot/outbid',getParentRoute: () => rootRouteImport
          })
const CompareMarketplaceIndexRoute = CompareMarketplaceIndexRouteImport.update({
            id: '/compare/marketplace/',path: '/compare/marketplace/',getParentRoute: () => rootRouteImport
          })
const CompareMarketplaceCompetitorRoute = CompareMarketplaceCompetitorRouteImport.update({
            id: '/compare/marketplace/$competitor',path: '/compare/marketplace/$competitor',getParentRoute: () => rootRouteImport
          })
const HistoryYearIndexRoute = HistoryYearIndexRouteImport.update({
            id: '/history/$year/',path: '/history/$year/',getParentRoute: () => rootRouteImport
          })
const MarketplaceUsernameServiceSlugRoute = MarketplaceUsernameServiceSlugRouteImport.update({
            id: '/$username/$serviceSlug',path: '/$username/$serviceSlug',getParentRoute: () => MarketplaceRoute
          })
const MarketplaceCategorySlugRoute = MarketplaceCategorySlugRouteImport.update({
            id: '/category/$slug',path: '/category/$slug',getParentRoute: () => MarketplaceRoute
          })
const MarketplaceGuidesIndexRoute = MarketplaceGuidesIndexRouteImport.update({
            id: '/guides/',path: '/guides/',getParentRoute: () => MarketplaceRoute
          })
const MarketplaceGuidesSlugRoute = MarketplaceGuidesSlugRouteImport.update({
            id: '/guides/$slug',path: '/guides/$slug',getParentRoute: () => MarketplaceRoute
          })
const MarketplaceOrderOrderIdRoute = MarketplaceOrderOrderIdRouteImport.update({
            id: '/order/$orderId',path: '/order/$orderId',getParentRoute: () => MarketplaceRoute
          })
const MarketplaceRequestRequestIdRoute = MarketplaceRequestRequestIdRouteImport.update({
            id: '/request/$requestId',path: '/request/$requestId',getParentRoute: () => MarketplaceRoute
          })
const MarketplaceServicesNewRoute = MarketplaceServicesNewRouteImport.update({
            id: '/services/new',path: '/services/new',getParentRoute: () => MarketplaceRoute
          })
const NcLiveAdmRoute = NcLiveAdmRouteImport.update({
            id: '/nc/live/adm',path: '/nc/live/adm',getParentRoute: () => rootRouteImport
          })
const HistoryYearMonthIndexRoute = HistoryYearMonthIndexRouteImport.update({
            id: '/history/$year/$month/',path: '/history/$year/$month/',getParentRoute: () => rootRouteImport
          })
const HistoryYearMonthBoardRoute = HistoryYearMonthBoardRouteImport.update({
            id: '/history/$year/$month/$board',path: '/history/$year/$month/$board',getParentRoute: () => rootRouteImport
          })
const MarketplaceServicesServiceIdEditRoute = MarketplaceServicesServiceIdEditRouteImport.update({
            id: '/services/$serviceId/edit',path: '/services/$serviceId/edit',getParentRoute: () => MarketplaceRoute
          })
const NcLiveAdmIndexRoute = NcLiveAdmIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => NcLiveAdmRoute
          })
const NcLiveAdmAccessRoute = NcLiveAdmAccessRouteImport.update({
            id: '/access',path: '/access',getParentRoute: () => NcLiveAdmRoute
          })
const NcLiveAdmAnalyticsRoute = NcLiveAdmAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => NcLiveAdmRoute
          })
const NcLiveAdmBoardsRoute = NcLiveAdmBoardsRouteImport.update({
            id: '/boards',path: '/boards',getParentRoute: () => NcLiveAdmRoute
          })
const NcLiveAdmCouponsRoute = NcLiveAdmCouponsRouteImport.update({
            id: '/coupons',path: '/coupons',getParentRoute: () => NcLiveAdmRoute
          })
const NcLiveAdmFinanceRoute = NcLiveAdmFinanceRouteImport.update({
            id: '/finance',path: '/finance',getParentRoute: () => NcLiveAdmRoute
          })
const NcLiveAdmHealthRoute = NcLiveAdmHealthRouteImport.update({
            id: '/health',path: '/health',getParentRoute: () => NcLiveAdmRoute
          })
const NcLiveAdmHistoryRoute = NcLiveAdmHistoryRouteImport.update({
            id: '/history',path: '/history',getParentRoute: () => NcLiveAdmRoute
          })
const NcLiveAdmLedgerRoute = NcLiveAdmLedgerRouteImport.update({
            id: '/ledger',path: '/ledger',getParentRoute: () => NcLiveAdmRoute
          })
const NcLiveAdmListingsRoute = NcLiveAdmListingsRouteImport.update({
            id: '/listings',path: '/listings',getParentRoute: () => NcLiveAdmRoute
          })
const NcLiveAdmLogsRoute = NcLiveAdmLogsRouteImport.update({
            id: '/logs',path: '/logs',getParentRoute: () => NcLiveAdmRoute
          })
const NcLiveAdmMarketplaceRoute = NcLiveAdmMarketplaceRouteImport.update({
            id: '/marketplace',path: '/marketplace',getParentRoute: () => NcLiveAdmRoute
          })
const NcLiveAdmMpRoute = NcLiveAdmMpRouteImport.update({
            id: '/mp',path: '/mp',getParentRoute: () => NcLiveAdmRoute
          })
const NcLiveAdmNotificationsRoute = NcLiveAdmNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => NcLiveAdmRoute
          })
const NcLiveAdmPaymentsRoute = NcLiveAdmPaymentsRouteImport.update({
            id: '/payments',path: '/payments',getParentRoute: () => NcLiveAdmRoute
          })
const NcLiveAdmSegmentsRoute = NcLiveAdmSegmentsRouteImport.update({
            id: '/segments',path: '/segments',getParentRoute: () => NcLiveAdmRoute
          })
const NcLiveAdmServicesRoute = NcLiveAdmServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => NcLiveAdmRoute
          })
const NcLiveAdmSettingsRoute = NcLiveAdmSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => NcLiveAdmRoute
          })
const NcLiveAdmSupportRoute = NcLiveAdmSupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => NcLiveAdmRoute
          })
const NcLiveAdmUsersRoute = NcLiveAdmUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => NcLiveAdmRoute
          })





const AppRouteChildren = {
  AppBillingRoute: AppBillingRoute,AppCollabsRoute: AppCollabsRoute,AppMessagesRoute: AppMessagesRoute,AppNotificationsRoute: AppNotificationsRoute,AppOrdersRoute: AppOrdersRoute,AppProRoute: AppProRoute,AppProfileRoute: AppProfileRoute,AppReferralsRoute: AppReferralsRoute,AppTransactionsRoute: AppTransactionsRoute,AppWalletsRoute: AppWalletsRoute,AppIndexRoute: AppIndexRoute,AppInvoicesIdRoute: AppInvoicesIdRoute,AppListingsIdRoute: AppListingsIdRoute,AppInvoicesIndexRoute: AppInvoicesIndexRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)




const MarketplaceRouteChildren = {
  MarketplaceCategoriesRoute: MarketplaceCategoriesRoute,MarketplaceExploreRoute: MarketplaceExploreRoute,MarketplaceFavoritesRoute: MarketplaceFavoritesRoute,MarketplaceHotRoute: MarketplaceHotRoute,MarketplaceOffersRoute: MarketplaceOffersRoute,MarketplaceOrdersRoute: MarketplaceOrdersRoute,MarketplaceRequestsRoute: MarketplaceRequestsRoute,MarketplaceSellRoute: MarketplaceSellRoute,MarketplaceIndexRoute: MarketplaceIndexRoute,MarketplaceUsernameServiceSlugRoute: MarketplaceUsernameServiceSlugRoute,MarketplaceCategorySlugRoute: MarketplaceCategorySlugRoute,MarketplaceGuidesSlugRoute: MarketplaceGuidesSlugRoute,MarketplaceOrderOrderIdRoute: MarketplaceOrderOrderIdRoute,MarketplaceRequestRequestIdRoute: MarketplaceRequestRequestIdRoute,MarketplaceServicesNewRoute: MarketplaceServicesNewRoute,MarketplaceGuidesIndexRoute: MarketplaceGuidesIndexRoute,MarketplaceServicesServiceIdEditRoute: MarketplaceServicesServiceIdEditRoute
}

const MarketplaceRouteWithChildren = MarketplaceRoute._addFileChildren(MarketplaceRouteChildren)




const NcLiveAdmRouteChildren = {
  NcLiveAdmAccessRoute: NcLiveAdmAccessRoute,NcLiveAdmAnalyticsRoute: NcLiveAdmAnalyticsRoute,NcLiveAdmBoardsRoute: NcLiveAdmBoardsRoute,NcLiveAdmCouponsRoute: NcLiveAdmCouponsRoute,NcLiveAdmFinanceRoute: NcLiveAdmFinanceRoute,NcLiveAdmHealthRoute: NcLiveAdmHealthRoute,NcLiveAdmHistoryRoute: NcLiveAdmHistoryRoute,NcLiveAdmLedgerRoute: NcLiveAdmLedgerRoute,NcLiveAdmListingsRoute: NcLiveAdmListingsRoute,NcLiveAdmLogsRoute: NcLiveAdmLogsRoute,NcLiveAdmMarketplaceRoute: NcLiveAdmMarketplaceRoute,NcLiveAdmMpRoute: NcLiveAdmMpRoute,NcLiveAdmNotificationsRoute: NcLiveAdmNotificationsRoute,NcLiveAdmPaymentsRoute: NcLiveAdmPaymentsRoute,NcLiveAdmSegmentsRoute: NcLiveAdmSegmentsRoute,NcLiveAdmServicesRoute: NcLiveAdmServicesRoute,NcLiveAdmSettingsRoute: NcLiveAdmSettingsRoute,NcLiveAdmSupportRoute: NcLiveAdmSupportRoute,NcLiveAdmUsersRoute: NcLiveAdmUsersRoute,NcLiveAdmIndexRoute: NcLiveAdmIndexRoute
}

const NcLiveAdmRouteWithChildren = NcLiveAdmRoute._addFileChildren(NcLiveAdmRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,CodeRoute: CodeRoute,AppRoute: AppRouteWithChildren,BoostRoute: BoostRoute,CategoriesRoute: CategoriesRoute,CookieRoute: CookieRoute,EarnRoute: EarnRoute,FundRoute: FundRoute,GetHotRoute: GetHotRoute,HowItWorksRoute: HowItWorksRoute,LoginRoute: LoginRoute,MarketplaceRoute: MarketplaceRouteWithChildren,PrivacyRoute: PrivacyRoute,PromoteRoute: PromoteRoute,ReferralsRoute: ReferralsRoute,ResetPasswordRoute: ResetPasswordRoute,TermsRoute: TermsRoute,WithdrawalRoute: WithdrawalRoute,CSlugRoute: CSlugRoute,HotTopicRoute: HotTopicRoute,PSlugRoute: PSlugRoute,ProSlugRoute: ProSlugRoute,UHandleRoute: UHandleRoute,UserSlugRoute: UserSlugRoute,HistoryIndexRoute: HistoryIndexRoute,HotIndexRoute: HotIndexRoute,CompareHotCompetitorRoute: CompareHotCompetitorRoute,CompareHotOutbidRoute: CompareHotOutbidRoute,CompareMarketplaceCompetitorRoute: CompareMarketplaceCompetitorRoute,NcLiveAdmRoute: NcLiveAdmRouteWithChildren,CompareHotIndexRoute: CompareHotIndexRoute,CompareMarketplaceIndexRoute: CompareMarketplaceIndexRoute,HistoryYearIndexRoute: HistoryYearIndexRoute,HistoryYearMonthBoardRoute: HistoryYearMonthBoardRoute,HistoryYearMonthIndexRoute: HistoryYearMonthIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)